import type { HTMLAttributes } from "react";
import type { CSSProperties } from "styled-components";
import type { ITypographyCommon, THeading } from "@/types/common";
import { StyledWrapperHeading } from "./styles";

export interface IHeading extends HTMLAttributes<HTMLHeadingElement>, Omit<ITypographyCommon, "sizeVariant"> {
  fontWeight?: CSSProperties["fontWeight"];
  textAlign?: CSSProperties["textAlign"];
  type?: THeading;
  variant?: THeading;
}

const Heading = ({
  size,
  color,
  type = "h2",
  variant,
  fontWeight,
  textAlign,
  disabled = false,
  ...props
}: IHeading) => {
  return (
    <StyledWrapperHeading
      as={type}
      $type={type}
      $variant={variant}
      $fontWeight={fontWeight}
      $textAlign={textAlign}
      {...props}
      $size={size}
      $color={color}
      $disabled={disabled}
    />
  );
};

export default Heading;
